import classes from './logged-out-route.module.sass';
import { Outlet } from 'react-router-dom';
import accessTokenService from '../../../Services/access-token.service';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const LoggedOutRoute = () => {
  const accessToken = accessTokenService.get();

  if (accessToken) {
    return <Spin className={classes.spinner} indicator={<LoadingOutlined spin />} size="large" >
      <Outlet />
    </Spin>
  }

  return <Outlet />;
};
